import { FC, SVGProps } from 'react';
import { Anchor, Box, Flex, Image, Text, UnstyledButton } from '@mantine/core';
import { UUID } from '@/types/types';
import { useDispatch } from 'react-redux';
import { creatorActions } from '@/store/slices/creatorSlice';
import classNames from 'classnames';
import HelpIcon from '@/assets/icons/help.svg?react';

interface Props {
	id?: UUID;
	isSelected: boolean;
	name: string;
	description: string;
	onSelect: () => void;
	shopUrl?: string;
	imagePath?: string;
	Icon?: FC<SVGProps<SVGSVGElement>>;
	onMouseOver?: () => void;
}

export const AccordionOptionCard: FC<Props> = ({
	id,
	isSelected,
	name,
	description,
	onSelect,
	shopUrl,
	imagePath,
	Icon,
	onMouseOver,
}) => {
	const dispatch = useDispatch();

	const handleOpenHelpDrawer = () => {
		dispatch(
			creatorActions.toogleHelpDrawer({
				helpDrawerOpened: true,
				helpDrawerData: {
					title: name,
					description,
					image: imagePath,
					shopUrl,
				},
			})
		);
	};

	return (
		<UnstyledButton
			key={id}
			className={classNames('option-card', {
				'option-card-selected': isSelected,
			})}
			p={6}
			onClick={onSelect}
			onMouseOver={onMouseOver}
		>
			<Flex className="image-container">
				{description.length > 10 && (
					<Anchor
						className="help-trigger"
						onClick={(e) => {
							e.stopPropagation();
							handleOpenHelpDrawer();
						}}
					>
						<HelpIcon />
					</Anchor>
				)}
				{!!imagePath && (
					<Image src={imagePath} w={100} h={70} mb="sm" loading="lazy" />
				)}
				{!!Icon && (
					<Box py="md">
						<Icon />
					</Box>
				)}
			</Flex>

			<Text size="xs" fw="bold">
				{name}
			</Text>
		</UnstyledButton>
	);
};
